import React from 'react'

import Form from '../../../packages/kiti/components/form/form/Form'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import BasicInfoSection from './sections/BasicInfoSection'
import { useSaveStocks } from './_requests/saveStocks'
import { useStockItem } from './_load/StockItemLoader'
import BuyInfoSection from './sections/BuyInfoSection'
import ControlInfoSection from './sections/ControlInfoSection'
import OthersInfoSection from './sections/OthersInfoSection'
import SellInfoSection from './sections/SellInfoSection'
import StockInfoSection from './sections/StockInfoSection'

const EditStockForm = () => {
  const stock = useStockItem()
  const [onSubmit, { loading, error }] = useSaveStocks()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={stock}>
      <BasicInfoSection />
      <ControlInfoSection />
      <StockInfoSection />
      <BuyInfoSection />
      <SellInfoSection />
      <OthersInfoSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditStockForm
